<nav class="pagination">
  <mat-paginator
    [length]="totalItems()"
    [pageSize]="itemsPerPage()"
    [pageSizeOptions]="[10, 20, 30, 40, 50]"
    [showFirstLastButtons]="true"
    (page)="handlePageEvent($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</nav>
